import {APP_INITIALIZER, NgModule} from '@angular/core';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {createTranslateLoader} from '@config/i18n.config';
import {HttpClient} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {SharedModule} from '@shared/shared.module';
import {UnsavedChangesGuard} from '@guards/unsaved-changes.guard';
import {appConfigFactory} from '@shared/factories/app-config.factory';
import {AppConfigService} from '@services/app-config.service';
import {LoginService} from '@services/login.service';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '@environments/environment';
import {I18nService} from '@services/i18n.service';
import {PermissionService} from '@services/permission.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    })
  ],
  providers: [
    UnsavedChangesGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigFactory,
      deps: [LoginService, AppConfigService, I18nService, PermissionService, HttpClient],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
